import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError, EMPTY, of } from 'rxjs';
import { catchError, tap, map, mergeMap } from 'rxjs/operators';
import { xml2json } from 'xml-js';
import { environment } from 'src/environments/environment';
import * as JsonToXML from 'js2xmlparser';
// console.log(JsonToXML.parse("person", this.obj));

const httpOptionsCatalyst = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
    }),
    responseType: 'text' as 'text'
};

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};
@Injectable({
    providedIn: 'root'
})
export class ApiService {

    baseCatalystUrl = environment.catalystURL;
    baseApiUrl = environment.apiUrl;


    constructor(private http: HttpClient) { }

    /**
     * Extracts the data from the response for further processing
     * @param res Response
     */
    private extractData(res: any) {

        if (res) {
            const rawJSON = xml2json(res, { compact: true, spaces: 4 });
            return JSON.parse(rawJSON);
        } else {
            return {};
        }

    }

    private extractJSONData(res: any) {

        const body = res;
        return body || {};

    }

    /**
     * Logs error messages and displays user-friendly error messages back to user
     * @param error HttpErrorResponse
     */
    private handleError(error: HttpErrorResponse) {

        if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.log(error.error);
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            if (error.status > 0){
                console.error(
                    `Backend returned code ${error.status}, ` +
                    `body was: ${error?.error?.message}`);
            }

        }

        let message = 'An unexpected error has happened. Please try again later.';

        if (error.error.message !== '') {
            message = error.error.message;
        }

        return throwError(message);

    }

    /**
     * Logs in a user based on email and password
     * @param data: any
     * @returns
     */
    login_user(data): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', '<Request>\
                                <EmailAddress>' + data.email + '</EmailAddress>\
                                <Password><![CDATA[' + data.password + ']]></Password>\
                                <ResetToken></ResetToken>\
                                <StudentNumber></StudentNumber>  \
                                <RegisterUserAccount>0</RegisterUserAccount>\
                            </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Logs in a user based on email and password
     * @param data
     * @returns
     */
    login_user_firsttime(data): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', '<Request>\
                                    <ResetToken>' + data.token + '</ResetToken>\
                                    <FirstTimeLogIn>1</FirstTimeLogIn>\
                                    <StudentNumber></StudentNumber>\
                                </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Registers a new user based on email and password
     * @param data
     * @returns
     */
    register_user(data): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', '<Request>\
                                <EmailAddress>' + data.email + '</EmailAddress>\
                                <Password><![CDATA[' + data.password + ']]></Password>\
                                <ResetToken></ResetToken>\
                                <StudentNumber></StudentNumber>  \
                                <RegisterUserAccount>1</RegisterUserAccount>\
                            </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Resends register email
     * @param data
     * @returns
     */
    resend_email_confirmation(email): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', '<Request>\
                                <EmailAddress>' + email + '</EmailAddress>\
                                <Password></Password>\
                                <RegisterUserAccount>0</RegisterUserAccount>\
                                <ResendRegistrationEmail>1</ResendRegistrationEmail>\
                                <FirstNames></FirstNames>\
                                <Surname></Surname>\
                </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Registers a new user based on email and password
     * @param data
     * @returns
     */
    register_user_new(data): Observable<any> {


        var options = {
            useSelfClosingTagIfEmpty: false
        };
        let XMLRequest = JsonToXML.parse('Request', data, options);

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', XMLRequest);

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        )

    }

    /**
     * Gets a password reset email containing a link to the reset password form
     * @param email
     * @returns
     */
    request_password_reset_email(email: string): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserAccountReset')
            .set('RequestXML', '<Request>\
                                <EmailAddress>' + email + '</EmailAddress>\
                            </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Resets a user's password. Requires token.
     * @param data
     * @returns
     */
    reset_password(data): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'UserLogin')
            .set('RequestXML', '<Request>\
                                <EmailAddress>' + data.email + '</EmailAddress>\
                                <Password><![CDATA[' + data.password + ']]></Password>\
                                <ResetToken>' + data.token + '</ResetToken>\
                                <StudentNumber></StudentNumber>  \
                                <RegisterUserAccount>0</RegisterUserAccount>\
                            </Request>'
            );

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches the complete course list
     */
    fetch_course_list(): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetCourseList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Fetches the complete product type list
     */
    fetch_product_type_list(): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetProductTypeGroupList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * BookingKey is optional and used for retrieving existing Bookings. 
     * RegionKey is required if no BookingKey is available, but you may as well pass it in always. 
     * NOTE: Include UserAccountKey to retrieve the Products with the current Cart data for that UserAccount - They will be <Selected> = 1, 
     * but not have a  BookedProductKey, like when you pass a BookingKey. The returned Product data will also 
     * contain the SessionGroupKey, SemesterKey, etc. that the users had selected for the Cart items. 
     * If a Product is no longer available, it will not be returned, even if it was added to the Cart. 
     * When a Booking is created, the Cart data will be cleared.
     * @param courseKey 
     */
    fetch_offered_subject_products(courseKey: any, productId = null, other = null): Observable<any> {


        let user: any = localStorage.getItem('user');
        let userKey = null;
        if (user && JSON.parse(user).Result.UserAccountKey._text) {
            userKey = JSON.parse(user).Result.UserAccountKey._text;
        }

        let payload = null;
        if (userKey) {
            if (productId) {
                let extraParam = '<BoughtWithProductKey>' + productId + '</BoughtWithProductKey>';
                if (other) {
                    extraParam = '<OtherStudyMethodsProductKey>' + productId + '</OtherStudyMethodsProductKey>';
                }
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><UserAccountKey>' + userKey + '</UserAccountKey><CourseKey>'
                        + courseKey + '</CourseKey>' + extraParam + '</Request>');
            } else {
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><UserAccountKey>' + userKey + '</UserAccountKey><CourseKey>' + courseKey + '</CourseKey></Request>');
            }

        } else {
            if (!productId) {
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey></Request>');
            } else {
                let extraParam = '<BoughtWithProductKey>' + productId + '</BoughtWithProductKey>';
                if (other) {
                    extraParam = '<OtherStudyMethodsProductKey>' + productId + '</OtherStudyMethodsProductKey>';
                }
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey>' + extraParam + '</Request>');
            }

        }

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_offered_subject_product(courseKey: any, productId = null): Observable<any> {


        const user: any = localStorage.getItem('user');
        let userKey = null;
        if (user && JSON.parse(user).Result.UserAccountKey._text) {
            userKey = JSON.parse(user).Result.UserAccountKey._text;
        }

        let payload = null;
        if (userKey) {
            if (productId) {

                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><UserAccountKey>' + userKey + '</UserAccountKey><CourseKey>' + courseKey + '</CourseKey></Request>');
            } else {
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><UserAccountKey>' + userKey + '</UserAccountKey><CourseKey>' + courseKey + '</CourseKey></Request>');
            }

        } else {
            if (!productId) {
                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey></Request>');
            } else {

                payload = new HttpParams()
                    .set('SystemID', environment.catalsytSystemID)
                    .set('RequestAction', 'GetOfferedSubjectProducts')
                    .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey></Request>');
            }

        }

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }
    /**
     * BookingKey is optional and used for retrieving existing Bookings. RegionKey is required if no 
     * BookingKey is available, but you may as well pass it in always. NOTE: Include UserAccountKey to 
     * retrieve the Products with the current Cart data for that UserAccount - They will be <Selected> = 1, 
     * but not have a  BookedProductKey, like when you pass a BookingKey. The returned Product data will also 
     * contain the SessionGroupKey, SemesterKey, etc. that the users had selected for the Cart items. 
     * If a Product is no longer available, it will not be returned, even if it was addedd to the Cart. 
     * When a Booking is created, the Cart data will be cleared.
     */
    fetch_offered_nonsubject_products(): Observable<any> {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetOfferedNonSubjectProducts')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_nonsubjects(): Observable<any> {

        return this.http.get(this.baseApiUrl + '/non-subjects', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }


    fetch_offered_nonsubject_products_by_course(courseKey: any): Observable<any> {

        let user: any = localStorage.getItem('user');
        let userKey = null;
        if (user && JSON.parse(user).Result.UserAccountKey._text) {
            userKey = JSON.parse(user).Result.UserAccountKey._text;
        }

        let payload = null;
        if (!courseKey) {
            payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'GetOfferedNonSubjectProducts')
                .set('RequestXML', '');
        }
        else if (userKey) {
            payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'GetOfferedNonSubjectProducts')
                .set('RequestXML', '<Request><UserAccountKey>' + userKey + '</UserAccountKey><CourseKey>' + courseKey + '</CourseKey></Request>');
        } else {
            payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'GetOfferedNonSubjectProducts')
                .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey></Request>');
        }


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_offered_nonsubject_products_by_course_bought_with(courseKey: any, prodKey: any): Observable<any> {


        let payload = null;


        payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetOfferedNonSubjectProducts')
            .set('RequestXML', '<Request><CourseKey>' + courseKey + '</CourseKey><BoughtWithProductKey>' + prodKey + '</BoughtWithProductKey></Request>');



        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );
    }

    /**
     * Fetches all institutions
     * @returns 
     */
    fetch_counters(): Observable<any> {

        return this.http.get(this.baseApiUrl + '/counters', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches 301 Redirects
     * @returns
     */
    fetch_redirect_urls(): Observable<any> {

        return this.http.get(this.baseApiUrl + '/redirects', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all institutions
     * @returns 
     */
    fetch_institutions(query: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/institutions' + query, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a single institution
     * @param id
     * @returns
     */
    fetch_institution(id: BigInteger): Observable<any> {

        return this.http.get(this.baseApiUrl + '/institutions/' + id, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all quotes
     * @returns
     */
    fetch_quotes(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/quotes' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all posts
     * @returns
     */
    fetch_posts(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/posts' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    /**
     * Fetches all study options
     * @returns
     */
    fetch_study_options(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/study-options' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    /**
     * Fetches all content cards
     * @returns
     */
    fetch_content_cards(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/content-cards' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    /**
     * Fetches all study options
     * @returns
     */
    fetch_progress(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/progress' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    /**
     * Fetches timetable
     * @returns 
     */

    fetch_timetable(CourseKey = 3, regionKey = null) {

        let xPayload = '<Request>\
                <CourseKey>' + CourseKey + '</CourseKey>\
            </Request>';

        if (regionKey) {
            xPayload = '<Request>\
            <CourseKey>' + CourseKey + '</CourseKey>\
            <RegionKey>' + regionKey + '</RegionKey>\
        </Request>';
        }



        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetTimeTable')
            .set('RequestXML', xPayload);


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );
    }

    fetch_timetable2(CourseKey = 3, regionKey = null, subjectLevelKey = null, subjectKey = null) {


        // Build XML
        let Xml = '<Request><CourseKey>' + CourseKey + '</CourseKey>';
        if (regionKey) { Xml = Xml + '<RegionKey>' + regionKey + '</RegionKey>' };
        if (subjectLevelKey) { Xml = Xml + '<SubjectLevelKey>' + subjectLevelKey + '</SubjectLevelKey>' };
        if (subjectKey) { Xml = Xml + '<SubjectKey>' + subjectKey + '</SubjectKey>' };
        let endXml = '</Request>';
        Xml = Xml + endXml;

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetTimeTable2')
            .set('RequestXML', Xml);


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );
    }


    /**
     * Fetches a single post
     * @returns
     */
    fetch_post(id): Observable<any> {

        return this.http.get(this.baseApiUrl + '/posts/' + id, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    fetch_post_draft(slug: string) {

        return this.http.get(this.baseApiUrl + '/posts/draft/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all subjects
     * @param id
     * @returns
     */
    fetch_subjects(course_key: any = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/subjects?course_key=' + course_key, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a single subject
     * @param id
     * @returns
     */
    fetch_subject(id: BigInteger): Observable<any> {

        return this.http.get(this.baseApiUrl + '/subjects/' + id, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a single subject
     * @param id
     * @returns
     */
    fetch_subject_slug(course: string, slug: string): Observable<any> {

        return this.http.get(this.baseApiUrl + '/courses/' + course + '/subjects/slugs/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a student's details
     * @param email
     * @param student_number
     * @returns
     */
    fetch_student(email: string, student_number: string) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetOfferedNonSubjectProducts')
            .set('RequestXML', '<Request>\
                                <Email>' + email + '</Email>\
                                <StudentNumber>' + student_number + '</StudentNumber>\
                                <ReturnDetail>1</ReturnDetail>\
                                <StudentKey></StudentKey>\
                                <BookingKey></BookingKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all areas
     * @returns
     */
    fetch_geographical_areas() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetGeographicalAreaList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Fetches all areas in SA
     * @returns
     */
    fetch_geographical_areas_sa() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetGeographicalAreaList')
            .set('RequestXML', '<Request><CountryKey>1</CountryKey></Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all areas in SA
     * @returns
     */
    fetch_geographical_areas_non_sa() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetGeographicalAreaList')
            .set('RequestXML', '<Request><ExcludeSouthAfrica>1</ExcludeSouthAfrica></Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all countries excluding SA
     * @returns
     */
    fetch_countries_no_sa() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetCountryList')
            .set('RequestXML', '<Request>\
                <ExcludeSouthAfrica>1</ExcludeSouthAfrica>\
            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all countries
     * @returns
     */
    fetch_countries() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetCountryList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches delivery methods. Used in cart.
     * @returns
     */
    fetch_delivery_methods() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetDeliveryMethodList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all genders
     * @returns
     */
    fetch_genders() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetGenderList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches all user titles
     * @returns
     */
    fetch_titles() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetTitleList')
            .set('RequestXML', '');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Sends a pro forma invoice to a user once a booking reference number has been generated
     * @param booking_key
     * @param email
     * @returns
     */
    get_proforma_invoice_mail(booking_key: any, email: string) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetProformaInvoice')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                                <Email>' + email + '</Email>\
                                <ForwardToThirdParty>0</ForwardToThirdParty>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Sends a pro forma invoice to a user once a booking reference number has been generated
     * @param booking_key
     * @param email
     * @returns
     */
    get_proforma_invoice(booking_key: any) {


        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetProformaInvoice')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                                <Email></Email>\
                                <ForwardToThirdParty>0</ForwardToThirdParty>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Sends a booking reference email once the booking reference number has been generated
     * @param booking_key
     * @returns
     */
    send_booking_reference_email(booking_key: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'SendBookingReferenceEmail')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

   /**
    * Sends a email once to confirm payment outcome
    * @param booking_key
    * @returns
    */
    send_payment_outcome_email(booking_key: any, paymethod: any, paymentmonthly: any, paymentsuccess: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'PostPaymentOutcome')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                                <PaymentMethodCode>' + paymethod + '</PaymentMethodCode>\
                                <PaymentMonthly>' + paymentmonthly + '</PaymentMonthly>\
                                <PaymentSuccessful>' + paymentsuccess + '</PaymentSuccessful>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Deletes a payment plan for a booking
     * @param booking_key
     * @returns
     */
    delete_payment_plan(booking_key: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'DeletePaymentPlan')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Creates a post payment based on booking, payment amount and if the user based on full
     * @param booking_key
     * @param payment_amount
     * @param paid_in_full
     * @returns
     */
    post_payment(booking_key: any, payment_amount: any, paid_in_full: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'PostPayment')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                                <PaymentAmount>' + payment_amount + '</PaymentAmount>\
                                <PaidInFull>' + paid_in_full + '</PaidInFull>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Maintain student
     */
    maintain_student(data) {

        var options = {
            useSelfClosingTagIfEmpty: false
        };
        let XMLRequest = JsonToXML.parse('Request', data, options);

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'MaintainStudent')
            .set('RequestXML', XMLRequest);

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }



    maintain_booking(
        deliveryDetails,
        billingDetails,
        studentInfo,
        employerDetails,
        userDetails = null,
        gaClientId = null
    ): Observable<any> {

        let DeliveryCountryKey = [];
        if (deliveryDetails.deliveryAddressGeo != null) {
            DeliveryCountryKey = deliveryDetails.deliveryAddressGeo.CountryKey._text;
        }
        let email = localStorage.getItem('user_email');
        let Booking = this.buildBookingProducts();
        let StudentKey = [];

        let user: any = JSON.parse(localStorage.getItem('user'));
        if (user && user.Result && user.Result.StudentKey && user.Result.StudentKey._text) {
            StudentKey = user.Result.StudentKey._text;
        }

        let DeliveryStateProvince = [];
        if (deliveryDetails?.addresForm?.Province) {
            DeliveryStateProvince = deliveryDetails.addresForm.Province;
        }
        let ResidentialStateProvince = [];
        if (billingDetails?.billingAddressForm?.Province) {
            ResidentialStateProvince = billingDetails.billingAddressForm.Province;
        }
        let billingForm = billingDetails.billingAddressForm;
        let addressForm = deliveryDetails.addresForm;

        // SA bank account
        let SABankAccount = 1;
        if (studentInfo.SaBankAccount == 'no') {
            SABankAccount = 0;
        }
        let CountryKey = 1;
        if (billingForm.DeliveryGeographicalAreaKey) {
            CountryKey = billingForm.DeliveryGeographicalAreaKey;
        }

        let InstituteContactID = [];
        if (studentInfo?.InstituteNumber) {
            InstituteContactID = studentInfo?.InstituteNumber;
        }

        // UTM stuff
        let userA: any = localStorage.getItem('user');
        let userAccountKey: any = '';
        if (userA) {
            try {
                userA = JSON.parse(userA);
                userAccountKey = userA.Result.UserAccountKey._text;
            } catch (err) { }
        }

        let Source = sessionStorage.getItem('utmSource') || '';
        let Medium = sessionStorage.getItem('utmMedium') || '';
        let Campaign = sessionStorage.getItem('utmCampaign') || '';
        let Content = sessionStorage.getItem('utmContent') || '';
        let Term = sessionStorage.getItem('utmTerm') || '';

        let Request2 = {
            UTM: {
                UserID: userAccountKey,
                ClientID: gaClientId,
                Source: Source,
                Medium: Medium,
                Campaign: Campaign,
                Content: Content,
                Term: Term
            },
            Student: {
                StudentKey: StudentKey,
                CountryKey: CountryKey,
                DeliveryCompanyName: addressForm.BussinessName,
                ResidentialCompanyName: billingForm.BussinessName,
                DeliverySurname: addressForm.Surname,
                DeliveryFirstName: addressForm.FirstNames,
                BillingSurname: billingForm.Surname,
                BillingFirstName: billingForm.FirstNames,
                DeliveryStateProvince: DeliveryStateProvince,
                Surname: userDetails.lastName,
                FirstNames: userDetails.firstName,
                TitleKey: '',
                TitleName: '',
                RSACitizen: '',
                IDPassportNumber: '',
                Cellphone: studentInfo.ContactNumber,
                SABankAccount: SABankAccount,
                Email: email,
                DateOfBirth: '',
                InstituteContactID: InstituteContactID,
                StudentNumber: '',
                ContactBeforeDespatch: [],
                PaymentByEmployer: billingDetails.PaymentByEmployer,
                EmployerCompanyName: employerDetails.CompanyName,
                EmployerContactName: employerDetails.ContactPerson,
                EmployerTelephone: employerDetails.ContactPersonNumber,
                EmployerEmail: [],
                EmployerVATNumber: employerDetails.CompanyVatNumber,
                EmployerPostalAddress: [],
                EmployerPostcode: [],
                DeliveryMethodKey: deliveryDetails.deliveryMethod,
                DeliverySameAsResidential: billingDetails.billingAddressTheSame,
                ResidentialAddressPostcode: billingForm.DeliveryAddressPostcode,
                GenderKey: '',
                GenderName: '',
                NationalityKey: [],
                DeliveryCountryKey: DeliveryCountryKey,
                ResidentialUnitNumber: billingForm.DeliveryUnitNumber,
                ResidentialStateProvince: ResidentialStateProvince,
                ResidentialBuildingName: billingForm.DeliveryBuildingName,
                ResidentialStreetNumber: billingForm.DeliveryStreetNumber,
                ResidentialStreetName: billingForm.DeliveryStreetNumber,
                ResidentialSuburb: billingForm.DeliverySuburb,
                ResidentialCity: billingForm.DeliveryCity,
                //ResidentialGeographicalAreaKey: billingForm.DeliveryGeographicalAreaKey,
                DeliveryUnitNumber: addressForm.DeliveryUnitNumber,
                DeliveryBuildingName: addressForm.DeliveryBuildingName,
                DeliveryStreetNumber: addressForm.DeliveryStreetNumber,
                DeliveryStreetName: addressForm.DeliveryStreetNumber,
                DeliverySuburb: addressForm.DeliverySuburb,
                DeliveryCity: addressForm.DeliveryCity,
                DeliveryAddressPostcode: addressForm.DeliveryAddressPostcode,
                DeliveryGeographicalAreaKey: addressForm.DeliveryGeographicalAreaKey,
            },
            Booking
        };

        var options = {
            useSelfClosingTagIfEmpty: false
        };
        let XMLRequest = JsonToXML.parse('Request', Request2, options);

        console.log('MAINTAIN BOOKING');
        console.log(XMLRequest);


        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'MaintainBooking')
            .set('RequestXML', XMLRequest);

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * "You pass in: BookingKey, PrefferedDayOfDebitOrder
     * The Service creates a PaymentPlan in Catalyst for the Booking (if no Payments already exist for the Booking,
     * in which case I will tell you so in the results: "OK: Existing Payments found for Booking")
     * The Service returns: PaymentPlan as a list of Payments Due: DO1,DO2,DO3,DO4 as well as the Amount Due now,
     * the Amount Paid and the Total Amount for the Booking. The default Payment Plan is for 4 future-dated
     * DO Payments, each for 20% of the Total amount due, leaving 20% due now.
     * You can even leave out the <PreferredDayOfDebitOrder> when calling once the DO's have already been created.
     * If DO's have not been ceated yet, it will default to the last day of the month when creating the DO's."
     * @param booking_key
     * @param payment_amount
     * @param paid_in_full
     * @returns
     */
    get_payment_plan(booking_key: any, preferred_dod: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetPaymentPlan ')
            .set('RequestXML', '<Request>\
                                <BookingKey>' + booking_key + '</BookingKey>\
                                <PrefferedDayOfDebitOrder>' + preferred_dod + '</PrefferedDayOfDebitOrder>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    post_course_enquiry(data: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'PostCourseEnquiry ')
            .set('RequestXML', '<Request>\
                                <Name>' + data.first_name + '</Name>\
                                <Surname>' + data.surname + '</Surname>\
                                <Email>' + data.email + '</Email>\
                                <ContactNumber>' + data.contact_number + '</ContactNumber>\
                                <CourseKey>' + data.course_key + '</CourseKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    get_study_methods(course_key: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetStudyMethods ')
            .set('RequestXML', '<Request>\
                                <CourseKey>' + course_key + '</CourseKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }


    /**
     * Get the pricing summary of the user's order
     * @param slug
     * @returns
     */
    get_order_summary(promo = '', deliveryMethod = ''): Observable<any> {


        // update the cart on catalyst
        this.save_cart_catalyst(promo, deliveryMethod).subscribe(
            (response: any) => {
                console.log(response);
            },
            (error) => {
            }
        );

        const Request = this.buildCartRequestSummary(promo, deliveryMethod);
        if (Request) {

            const options = {
                useSelfClosingTagIfEmpty: false
            };

            const XMLRequest = JsonToXML.parse('Request', Request, options);


            const payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'GetOrderSummary')
                .set('RequestXML', XMLRequest);

            return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
                map(res => this.extractData(res)),
                catchError(this.handleError)
            );

        } else {
            console.log('RETURNING');
            return of({});
        }

    }


    save_cart_catalyst(promo = '', deliveryMethod = ''): Observable<any> {

        const storeroom = localStorage.getItem('promo_code');
        if (storeroom) {
            promo = JSON.parse(storeroom);
        }

        const Request = this.buildCartRequestSummary(promo, deliveryMethod);

        if (Request?.UserAccount?.UserAccountKey) {

            const options = {
                useSelfClosingTagIfEmpty: false
            };

            let XMLRequest = JsonToXML.parse('Request', Request, options);

            const payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'SaveCurrentCart')
                .set('RequestXML', XMLRequest);

            return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
                map(res => this.extractData(res)),
                catchError(this.handleError)
            );

        } else {
            console.log('No user key not saving');
            return of({});
        }

    }


    get_region_list(product_key: any = '') {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetRegionList ')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + product_key + '</ProductKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Weekend/Weekdays. ProductKey and RegionKey are Optional and are used when adding to Cart. 
     * XML can be left out entirely to return all SessionGroupTypes
     * @param product_key
     * @param region_key
     * @returns
     */
    get_session_group_type_list(product_key: any = '', region_key: any = '') {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetSessionGroupTypeList')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + product_key + '</ProductKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    get_session_group_list(product_key: any = '', region_key: any = '') {

        if (!region_key) {
            region_key = '';
        }

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetSessionGroupList')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + product_key + '</ProductKey>\
                                <RegionKey>' + region_key + '</RegionKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Get info about what Lookups are required for the Product being added to the cart.
     * Then call each Lookup population Service as required.
     * Returns fields with value of 1 or 0: <PromptForSemester>, <PromptForRegion>,
     * <PromptForSessionGroupType>, <PromptForExamDate>, <PromptForQuantity>
     * @param product_key
     * @returns
     */
    get_product_purchase_lookups(product_key: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetProductPurchaseLookups ')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + (product_key ? product_key : '') + '</ProductKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * ProductKey and RegionKey are Mandatory and are used when adding to Cart. 
     * @param product_key
     * @param region_key
     * @returns
     */
    get_exam_date_list(product_key: any, region_key: any = '') {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetExamDateList ')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + product_key + '</ProductKey>\
                                <RegionKey>' + region_key + '</RegionKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * ProductKey and RegionKey are Mandatory and are used when adding to Cart. 
     * @param product_key
     * @param region_key
     * @returns
     */
    get_semester_list(product_key: any) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetSemesterList ')
            .set('RequestXML', '<Request>\
                                <ProductKey>' + product_key + '</ProductKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Passing StudentKey in XML will return Student for StudentKey without checking. Pass 1 or 0 to return
     * Student Details when using WebService to Check if Student exists. Includes Display Values for Lookup
     * fields such as Title, Gender and GeographicalArea, to avoid having to populate Lookups on load.
     * Pass BookingKey in for existing Booking, when user returning.
     * @param data
     * @returns
     */
    get_student(email, key) {
        console.log('GetStudent API call: ', `${this.baseCatalystUrl}`, email);
        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetStudent ')
            .set('RequestXML', '<Request>\
                                <Email>' + email + '</Email>\
                                <StudentNumber></StudentNumber>\
                                <ReturnDetail>1</ReturnDetail>\
                                <StudentKey>' + key + '</StudentKey>\
                                <BookingKey></BookingKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    get_student_no_email(key) {
        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetStudent ')
            .set('RequestXML', '<Request>\
                                <StudentNumber></StudentNumber>\
                                <ReturnDetail>1</ReturnDetail>\
                                <StudentKey>' + key + '</StudentKey>\
                                <BookingKey></BookingKey>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Send the student the student number in an email
     * @param email
     * @returns
     */
    send_forgotten_student_number_email(email: string) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'SendForgottenStudentNumberEmail ')
            .set('RequestXML', '<Request>\
                                <Email>' + email + '</Email>\
                            </Request>');

        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a content page based on the slug
     * @param slug
     * @returns
     */
    fetch_pages(querystring: any = '') {

        return this.http.get(this.baseApiUrl + '/pages-nested' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a content page based on the slug
     * @param slug1
     * @returns
     */
    fetch_page(slug: string) {

        return this.http.get(this.baseApiUrl + '/pages/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }


    /**
     * Syncs the user's cart with the API
     * @param slug
     * @returns
     */
    sync_user_cart(slug): Observable<any> {

        let Request = this.buildCartRequest();
        if (Request?.UserAccount?.UserAccountKey) {
            var options = {
                useSelfClosingTagIfEmpty: false
            };

            let XMLRequest = JsonToXML.parse('Request', Request, options);

            const payload = new HttpParams()
                .set('SystemID', environment.catalsytSystemID)
                .set('RequestAction', 'SaveCurrentCart')
                .set('RequestXML', XMLRequest);

            return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
                map(res => this.extractData(res)),
                catchError(this.handleError)
            );


        } else {
            console.log('No user key not saving');
            return of({});
        }


    }

    buildCartRequest(promo = '') {

        let cart: any = localStorage.getItem('cart');
        let user: any = localStorage.getItem('user');
        // Check if the user has a cart in storage
        cart = JSON.parse(cart);

        if (cart && user) {
            let userKey = JSON.parse(user).Result.UserAccountKey._text;


            let courseKey = '';
            let regionKey = '';
            let pamentMonthly = '';


            let Product = [];
            cart.forEach(subject => {
                if (subject.catalystSubject?.CourseKey._text) {
                    courseKey = subject.catalystSubject?.CourseKey._text;
                }
                if (subject.regionKey) {
                    regionKey = subject.regionKey;
                }
                if (subject.PaymentMonthly == 1 || subject.PaymentMonthly == 0) {
                    pamentMonthly = subject.PaymentMonthly;
                }
                let subObject = {
                    ProductKey: (subject.productKey ? subject.productKey : ''),
                    SemesterKey: (subject.SemesterKey ? subject.SemesterKey : ''),
                    //  SessionGroupKey: subject.product.SessionGroupKey,
                    SessionGroupKey: '',
                    ExamDateKey: '',
                }
                Product.push(subObject);
            });
            let Request;

            if (promo == '') {
                Request = {
                    UserAccount: {
                        UserAccountKey: userKey,
                        CourseKey: courseKey,
                        RegionKey: regionKey,
                        PaymentMonthly: pamentMonthly,
                        Products: {
                            Product
                        }
                    }
                };
            } else {
                Request = {
                    UserAccount: {
                        UserAccountKey: userKey,
                        CourseKey: courseKey,
                        RegionKey: regionKey,
                        PaymentMonthly: pamentMonthly,
                        PromotionCode: promo,
                        Products: {
                            Product
                        }
                    }
                };
            }


            return Request;
        } else {
            return null;
        }

    }

    buildCartRequestSummary(promo = '', deliveryMethod = '') {

        let cart: any = localStorage.getItem('cart');
        let user: any = localStorage.getItem('user');
        // Check if the user has a cart in storage
        cart = JSON.parse(cart);

        if (cart) {
            let userKey = '';

            if (user) {
                userKey = JSON.parse(user).Result.UserAccountKey._text;
            }


            let courseKey = '';
            let regionKey = '';
            let pamentMonthly = '';
            let deliveryMethodKey = deliveryMethod;


            let Product = [];
            cart.forEach(subject => {
                if (subject.catalystSubject?.CourseKey._text) {
                    courseKey = subject.catalystSubject?.CourseKey._text;
                }
                if (subject.regionKey) {
                    regionKey = subject.regionKey;
                }
                if (subject.PaymentMonthly == 1 || subject.PaymentMonthly == 0) {
                    pamentMonthly = subject.PaymentMonthly;
                }
                let subObject = {
                    ProductKey: (subject.productKey ? subject.productKey : ''),
                    SemesterKey: (subject.SemesterKey ? subject.SemesterKey : ''),
                    //  SessionGroupKey: subject.product.SessionGroupKey,
                    SessionGroupKey: '',
                    ExamDateKey: '',
                }
                Product.push(subObject);
            });
            let Request;

            if (promo == '') {
                Request = {
                    UserAccount: {
                        UserAccountKey: userKey,
                        CourseKey: courseKey,
                        RegionKey: regionKey,
                        PaymentMonthly: pamentMonthly,
                        DeliveryMethodKey: deliveryMethodKey,
                        Products: {
                            Product
                        }
                    }
                };
            } else {
                Request = {
                    UserAccount: {
                        UserAccountKey: userKey,
                        CourseKey: courseKey,
                        RegionKey: regionKey,
                        PaymentMonthly: pamentMonthly,
                        PromotionCode: promo,
                        DeliveryMethodKey: deliveryMethodKey,
                        Products: {
                            Product
                        }
                    }
                };
            }


            return Request;
        } else {
            return null;
        }

    }

    buildBookingProducts() {

        let cart: any = localStorage.getItem('cart');
        let user: any = localStorage.getItem('user');

        // Check if the user has a cart in storage
        cart = JSON.parse(cart);

        if (cart && user) {
            let userKey = JSON.parse(user).Result.UserAccountKey._text;


            let courseKey = '';
            let regionKey = '';
            let pamentMonthly = ''


            // promo code
            let PromoCode = '';
            let storedpromo = localStorage.getItem('promo_code');
            if (storedpromo) {
                PromoCode = JSON.parse(storedpromo);
            }



            let Product = [];
            cart.forEach(subject => {
                if (subject.catalystSubject?.CourseKey._text) {
                    courseKey = subject.catalystSubject?.CourseKey._text;
                }
                if (subject.regionKey) {
                    regionKey = subject.regionKey;
                }
                if (subject.PaymentMonthly == 1 || subject.PaymentMonthly == 0) {
                    pamentMonthly = subject.PaymentMonthly;
                }
                let subObject = {
                    ProductKey: (subject.productKey ? subject.productKey : ''),
                    SemesterKey: (subject.SemesterKey ? subject.SemesterKey : ''),
                    UnitPrice: subject.product.UnitPrice._text,
                    BookedProductKey: '',
                    Selected: 1,
                    Quantity: 1,
                    SessionGroupTypeCode: '',
                    ExamDateKey: '',
                }
                Product.push(subObject);
            });
            let Booking = {};
            if (PromoCode) {
                Booking = {
                    BookingKey: '',
                    CourseKey: courseKey,
                    RegionKey: regionKey,
                    PromotionCode: PromoCode,
                    PaymentMonthly: pamentMonthly,
                    Products: {
                        Product
                    }

                };
            } else {
                Booking = {
                    BookingKey: '',
                    CourseKey: courseKey,
                    RegionKey: regionKey,
                    // PromotionCode: PromoCode,
                    PaymentMonthly: pamentMonthly,
                    Products: {
                        Product
                    }

                };
            }



            return Booking;
        } else {
            return null;
        }
    }
    /**
     * Fetches a single subject
     * @param id
     * @returns
     */
    fetch_study_methods(): Observable<any> {

        return this.http.get(this.baseApiUrl + '/study-methods', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a single study method
     * @param id
     * @returns
     */
    fetch_study_method(slug: string): Observable<any> {

        return this.http.get(this.baseApiUrl + '/study-methods/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches the study methods for a subject
     * @param id
     * @returns
     */
    fetch_subject_study_methods(key: any): Observable<any> {

        return this.http.get(this.baseApiUrl + '/subjects/' + key + '/study-methods/', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /**
     * Fetches a single subject
     * Persists the cart against the user_key in the Refresh API
     * @returns
     */
    cart_persist(): Observable<any> {


        this.save_cart_catalyst().subscribe(
            (response: any) => {
                console.log(response);
            },
            (error) => {
            }
        );

        let cart: any = localStorage.getItem('cart');
        let user: any = localStorage.getItem('user');
        //Check if the user has a cart in storage
        if (cart && user) {
            cart = JSON.parse(cart);

            let userKey = JSON.parse(user).Result.UserAccountKey._text;

            let data = {
                'user_key': userKey,
                'cart': cart
            };
            return this.http.post(this.baseApiUrl + '/save-cart', data, httpOptions).pipe(
                map(this.extractJSONData),
                catchError(this.handleError)
            );
        } else {
            return of({});
        }

    }

    /**
     * Persists the cart against the user_key in the Refresh API
     * @returns
     */
    cart_load(): Observable<any> {

        let user: any = localStorage.getItem('user');
        let userKey = JSON.parse(user).Result.UserAccountKey._text;

        return this.http.get(this.baseApiUrl + '/get-cart/' + userKey, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    /**
     * Persists the cart against the user_key in the Refresh API
     * @returns
     */
    cart_clear(): Observable<any> {

        let user: any = localStorage.getItem('user');
        let userKey = JSON.parse(user).Result.UserAccountKey._text;
        let data = {
            'user_key': userKey,
        };

        return this.http.post(this.baseApiUrl + '/delete-cart/', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    /* Fetches a single subject
     * @param id 
     * @returns 
     */
    fetch_support_sections(querystring: string = ''): Observable<any> {

        return this.http.get(this.baseApiUrl + '/support' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    init_payment(payload: any) {
        return this.http
            .post(
                `${this.baseApiUrl}/payments/init-transaction`,
                payload,
                httpOptions
            )
            .pipe(
                map((res: any) => this.extractJSONData(res)),
                catchError(this.handleError)
            );
    }

    makePayments(payload: any) {
        return this.http
            .post(`${this.baseApiUrl}/payments/pay`, payload, httpOptions)
            .pipe(
                map((res: any) => this.extractJSONData(res)),
                catchError(this.handleError)
            );
    }


    confirmPayments(payload: any) {
        return this.http
            .post(`${this.baseApiUrl}/payments/confirmation`, payload, httpOptions)
            .pipe(
                map((res: any) => this.extractJSONData(res)),
                catchError(this.handleError)
            );
    }

    fetchContactInformation() {
        return this.http.get(this.baseApiUrl + '/contact', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    fetchFooterItems() {
        return this.http.get(this.baseApiUrl + '/footers', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }


    fetch_page_builder(slug: string) {

        return this.http.get(this.baseApiUrl + '/pb/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    fetch_page_builder_draft(slug: string) {

        return this.http.get(this.baseApiUrl + '/pb/draft/' + slug, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    fetch_page_builder_institution(id: Number) {

        return this.http.get(this.baseApiUrl + '/pb-institute/' + id, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    fetch_notification() {

        return this.http.get(this.baseApiUrl + '/notifications', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }

    fetch_headers(querystring: string = '') {

        return this.http.get(this.baseApiUrl + '/navigation-header-items' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );

    }


    add_to_mail_list(email, name = null): Observable<any> {

        let data = {
            "email": email,
            "name": name,
        }

        return this.http.post(this.baseApiUrl + '/newsletter-sub', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    add_to_registration_list(email, name = null, surname = null): Observable<any> {

        let data = {
            "email": email,
            "firstName": name,
            "lastName": surname
        };

        return this.http.post(this.baseApiUrl + '/registration-sub', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    submit_contact_form_data(data: any = {}): Observable<any> {

        return this.http.post(this.baseApiUrl + '/forms/general-contact', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    submit_register_form_data(data: any = {}): Observable<any> {
        return this.http.post(this.baseApiUrl + '/forms/registration-utm', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    submit_booking_form_data(data: any = {}): Observable<any> {
        return this.http.post(this.baseApiUrl + '/forms/booking-utm', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

    submit_event_application_form_data(data: any = {}): Observable<any> {

        return this.http.post(this.baseApiUrl + '/forms/event-application', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    submit_lead_gen_form_data(data: any = {}): Observable<any> {

        return this.http.post(this.baseApiUrl + '/forms/lead-gen', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    submit_tutor_support_form_data(data: any = {}): Observable<any> {

        return this.http.post(this.baseApiUrl + '/forms/tutor-support', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    submit_value_add_form_data(data: any = {}): Observable<any> {

        return this.http.post(this.baseApiUrl + '/forms/value-add', data, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );


    }

    fetch_form_options() {

        return this.http.get(this.baseApiUrl + '/form-options/general-contact', httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        )

    }

    fetch_event_types() {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetEventTypeList')
            .set('RequestXML', '');


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_events(eventKey) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetEventList')
            .set('RequestXML', '<Request><EventTypeKey>' + eventKey + '</EventTypeKey></Request>');


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_event_sessions(eventKey) {

        const payload = new HttpParams()
            .set('SystemID', environment.catalsytSystemID)
            .set('RequestAction', 'GetEventSessionList')
            .set('RequestXML', '<Request><EventKey>' + eventKey + '</EventKey></Request>');


        return this.http.post(`${this.baseCatalystUrl}`, payload.toString(), httpOptionsCatalyst).pipe(
            map(res => this.extractData(res)),
            catchError(this.handleError)
        );

    }

    fetch_standalone_text(querystring: string = '') {

        return this.http.get(this.baseApiUrl + '/standalone-texts' + querystring, httpOptions).pipe(
            map(this.extractJSONData),
            catchError(this.handleError)
        );
    }

}
